import { useEffect, useState, useRef } from "react";
import {
  callTranscript,
  downloadRecordings,
  getToken,
  regenerateTranscript,
} from "../../services/api";
import Loader from "../loader";
import WaveSurfer from "wavesurfer.js";
// import data from "./tempData";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import Tooltip from "@mui/material/Tooltip";
import { Filter } from "bad-words";
import Notification from "../../atom/Notification";
import store from "../../toolkit/store";
import * as loaderLottie from "../../utils/lottie/loaderLottie.json";

import {
  AudioFileIcon,
  CircleTick,
  DownArrow,
  DownloadIcon,
  PlayButton,
  RegenerateIcon,
  TextFileIcon,
  UpArrow,
} from "../../utils/icons/defaultIcons";
import SearchIcon from "@mui/icons-material/Search";
import { getENVData } from "../../config/environment";
import { useSelector } from "react-redux";
import Lottiefy from "../../atom/lottie/lottie";
import Modal from "../../atom/modal";
import FadeIn from "react-fade-in";
import TrainYourModel from "./trainYourModel";
import ThemedButton from "../../atom/ThemedButton/themedButton";
import { useLocation, useNavigate } from "react-router-dom";
import { downloadFileFromURL } from "../../services/utilities";
import CustomTooltip from "../../atom/customTooltip";
import { log } from "node:console";

const TranscribeModalCopy = (props: any) => {
  const filter = new Filter({ placeHolder: "*" });
  const token = useSelector((state: any) => state.auth.token);
  const [currentIndex, setCurrentIndex] = useState(0);
  const highlightsRef = useRef<NodeListOf<HTMLElement> | null>(null);
  const { transcribe, setTranscribe } = props;
  let container: any;
  let userScrolling: boolean = false;
  const [diarisation, setDiarisation] = useState<any>([]);
  const [transcript, setTranscript] = useState<any>({});
  const [searchText, setSearchText] = useState("");
  const [audioBlob, setAudioBlob] = useState();
  const [audioUrl, setAudioUrl] = useState(null);
  const [regenLoading, setRegenLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchResults, setSearchResults] = useState<any>(0);
  const [transcriptLoading, setTranscriptLoading] = useState(true);
  const waveformRef = useRef<any>(null);
  const wavesurferRef = useRef<any>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [trainingModal, setTrainingModal] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const transcriptRefs = useRef<any>([]); // To store refs for each transcript item
  const transcriptContainerRef = useRef<HTMLDivElement>(null);
  const scrollTimeoutRef = useRef<NodeJS.Timeout | null>(null); // Scroll timeout ref
  const [initialLoading, setInitialLoading] = useState<boolean>(true);
  const [processCompleted, setProcessCompleted] = useState(false);
  const fixedHeight = "h-[150px] min-h-[150px] max-h-[200px]";

  const getId = () => {
    const state: any = store.getState();
    if (state.Simulation.simulate?.uuid) {
      return state.Simulation.simulate.uuid;
    } else {
      return state.Permissions.accountId;
    }
  };
  const togglePlay = () => {
    if (wavesurferRef.current) {
      wavesurferRef.current.playPause();
      setIsPlaying(!isPlaying);
    }
  };

  const seekForward = () => {
    if (wavesurferRef.current) {
      userScrolling = false;
      wavesurferRef.current.skipForward(10);
    }
  };

  const seekBackward = () => {
    if (wavesurferRef.current) {
      userScrolling = false;
      wavesurferRef.current.skipBackward(10);
    }
  };
  const playFromTime = (timeInSeconds: number) => {
    setSelectedText("");
    if (wavesurferRef.current) {
      userScrolling = false;
      const duration = wavesurferRef.current.getDuration(); // Get total duration
      const position = timeInSeconds / duration; // Calculate position (0 to 1)
      wavesurferRef.current.seekTo(position); // Seek to the position
      wavesurferRef.current.play(); // Play from the position
      setIsPlaying(true);
    }
  };
  const scrollToHighlight = (index: number) => {
    if (highlightsRef.current && highlightsRef.current[index]) {
      // Remove 'active' class from all highlights
      highlightsRef.current.forEach((el) => el.classList.remove("active"));

      // Add 'active' class to the current highlight
      const currentHighlight = highlightsRef.current[index];
      currentHighlight.classList.add("active");

      // Scroll to the current highlight
      currentHighlight.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };
  const handleNext = () => {
    if (
      highlightsRef.current &&
      currentIndex < highlightsRef.current.length - 1
    ) {
      setCurrentIndex((prev) => {
        const nextIndex = prev + 1;
        scrollToHighlight(nextIndex);
        return nextIndex;
      });
    }
  };
  const handlePrev = () => {
    if (highlightsRef.current && currentIndex > 0) {
      setCurrentIndex((prev) => {
        const prevIndex = prev - 1;
        scrollToHighlight(prevIndex);
        return prevIndex;
      });
    }
  };
  const handleSearch = (text: string) => {
    setSearchText(text);
    setTimeout(() => {
      highlightsRef.current = document.querySelectorAll("mark.highlight");
      if (highlightsRef.current?.length) {
        setSearchResults(highlightsRef.current.length);
        scrollToHighlight(0);
        setCurrentIndex(0);
        setSearchResults(true);
      } else {
        setSearchResults(0);
        setCurrentIndex(0);
        setSearchResults(false);
        scrollToHighlight(0);
      }
    }, 200);
  };
  const highlightText = (value: string): string => {
    if (!searchText) return value;
    const regex = new RegExp(`(${searchText})`, "gi");
    return value.replace(regex, `<mark class="highlight">$1</mark>`); // Wrap matched text with <mark> tag
  };
  const fetchAudio = async () => {
    try {
      setIsLoading(true);
      let src;
      if (transcribe?.type === "call_recordings") {
        src = transcribe.recordings_l[0]?.file_path.replace(
          "/opt/vaspian/data/recordings/",
          `${
            getENVData().baseURL
          }cr/tenants/${getId()}/call_recordings/download/`,
        );
      } else if (transcribe?.type === "legacy_call_recordings") {
        src = transcribe.recordings_l[0]?.file_path.replace(
          "/vdata/shared/recordings/",
          `${
            getENVData().baseURL
          }cr/tenants/${getId()}/call_recordings/download/legacy/`,
        );
      }
      const response: any = await fetch(src, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      });
      if (!response.ok) {
        throw new Error("Failed to fetch audio file");
      }
      const blob = await response.blob();
      const url: any = URL.createObjectURL(blob);
      setAudioBlob(blob);
      setAudioUrl(url);
      console.log("audioUrl", url);
      setIsLoading(false);
    } catch (error) {
      console.error("Error loading audio:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };
  function splitTextIntoArrays(text: any, duration: any, startTime: any) {
    const words = text.toString().split(/\s+/); // Split the text into words
    // console.log("###----- text", text);
    // console.log("###----- words", words);

    const totalWords = words.length;
    // console.log("###----- totalWords", totalWords);
    // console.log("###----- duration", duration);
    const chunkSize = Math.ceil(totalWords / (duration / 1000)); // Calculate the number of words per chunk
    // console.log("###----- chunkSize", chunkSize);

    const expTime = duration / (totalWords / chunkSize); // Calculate the expected time for each chunk;
    // console.log("###----- expTime", expTime);
    const result = [];
    for (let i = 0, j = 0; i < totalWords; i += chunkSize, j++) {
      const data = {
        chunk: words.slice(i, i + chunkSize).join(" "),
        start_time: expTime * j + startTime,
        totalWords,
        chunkSize,
        startTime,
        expTime,
        end: expTime * (j + 1) + startTime,
      };
      result.push(data); // Join words into a chunk with spaces
      // console.log("###----- data", data);
    }
    return result;
  }

  const TranscriptSegmentation = (data: any) => {
    let result: any = [...data];
    result.map((item: any, index: number) => {
      item.duration = item.end_time - item.start_time;
      const part = splitTextIntoArrays(
        filter.clean(item.text),
        item.duration,
        item.start_time,
      );
      item.textParts = part;
    });
    return result;
  };
  const handleScroll = () => {
    userScrolling = true;
    if (scrollTimeoutRef.current) clearTimeout(scrollTimeoutRef.current);
    scrollTimeoutRef.current = setTimeout(() => {
      userScrolling = false;
    }, 2000);
  };
  const downloadTranscript = () => {
    if (diarisation.length > 0) {
      let summary = "";
      if (transcript.summary) {
        summary =
          `Summary\n` +
          `-----------------------------------------\n\n` +
          `${transcript.summary.replace(/#/g, "")}\n\n`;
      }
      let keywords = "";
      console.log(`\x1b[42m ${JSON.stringify(transcript.keywords)} \x1b[0m`);

      if (transcript.keywords) {
        keywords =
          `Keywords\n` +
          `-----------------------------------------\n\n` +
          `${transcript.keywords
            .map((item: string) =>
              item.replace(/\b\w/g, (char) => char.toUpperCase()),
            )
            .join(", ")}\n\n`;
      }
      console.log("diarization", diarisation);
      const text =
        `\nCall details\n` +
        `-----------------------------------------\n\n` +
        `Calling number: ${transcribe.calling_number}\n` +
        `Dialed number: ${transcribe.dialed_number}\n` +
        `Extension: ${transcribe.orig_ext}\n\n` +
        `start_time: ${transcribe.start_date + " " + transcribe.start_time}\n` +
        `End: ${transcribe.start_date + " " + transcribe.end_time}\n` +
        `Duration: ${transcribe.total_time}\n\n` +
        `${summary}` +
        `${keywords}` +
        "Transcript\n" +
        `-----------------------------------------\n\n` +
        diarisation
          .map((item: any) => {
            let text = "";
            text += item.speaker
              ? ` ${item.speaker} (${formatTime(item.start_time / 1000)})\n`
              : "";
            text += filter.clean(item.text);
            return text;
          })
          .join("\n\n");
      const blob = new Blob([text], { type: "text/plain" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Call Transcription ${transcribe.calling_number}-${
        transcribe.start_date + " " + transcribe.start_time
      }.txt`;
      a.click();
      URL.revokeObjectURL(url);
    }
  };

  const downloadAudio = async () => {
    if (!isLoading) {
      const link = document.createElement("a");
      link.href = audioUrl || "";
      link.target = "_blank";
      const date: any = new Date();
      link.setAttribute(
        "download",
        `${"Call Recordings"} ${date.toLocaleString("en-US", {
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
        })}.${"mp3"}`,
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (audioUrl && waveformRef.current) {
        wavesurferRef.current = WaveSurfer.create({
          container: waveformRef.current,
          waveColor: "#9eac9e",
          progressColor: "rgb(254, 186, 18)",
          barHeight: 4, // Height multiplier for bars
          height: 80,
        });
        wavesurferRef.current.load(audioUrl);
        wavesurferRef.current.on("audioprocess", () => {
          const current = wavesurferRef.current.getCurrentTime();
          setCurrentTime(current);

          if (!userScrolling) {
            diarisation.forEach((item: any, index: number) => {
              if (
                current * 1000 >= item.start_time &&
                current * 1000 <= item.end_time
              ) {
                const ref = transcriptRefs.current[index];
                if (ref) {
                  ref.scrollIntoView({ behavior: "smooth", block: "center" });
                }
              }
            });
          }
        });
        wavesurferRef.current.on("ready", () => {
          setDuration(wavesurferRef.current.getDuration());
        });
        wavesurferRef.current.on("finish", () => {
          setIsPlaying(false); // Update UI to reflect stopped state
        });
      }
      let container = transcriptContainerRef.current;
      if (container) {
        container.addEventListener("scroll", handleScroll);
      }
    }, 1000);
    return () => {
      if (wavesurferRef.current) {
        wavesurferRef.current.destroy();
      }
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [audioUrl]);

  const [selectedText, setSelectedText] = useState("");
  const [playItem, setPlayItem] = useState<any>({});
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const [mouseDownPos, setMouseDownPos] = useState({ x: 0, y: 0 });
  const menuRef = useRef(null);
  const onCloseModal = () => {
    setTrainingModal(false);
  };
  const handleMouseUp = (item: any) => {
    setPlayItem(item);
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) {
      playFromTime(item.start_time / 1000);
      setSelectedText("");
      return;
    }
    const selectedText = selection.toString();
    console.log("Selection:", selectedText);
    if (selectedText !== "") {
      setSelectedText(selectedText);
      if (transcriptContainerRef.current) {
        setMenuPosition({
          top: mouseDownPos.y, // Use stored mouse position + scroll offset
          left: mouseDownPos.x, // Align with mouse position
        });
      }
    } else {
      playFromTime(item.start_time / 1000);
      setSelectedText("");
    }
  };

  const handleMouseDown = (event: React.MouseEvent) => {
    if (!transcriptContainerRef.current) return;

    const containerRect =
      transcriptContainerRef.current.getBoundingClientRect();
    setMouseDownPos({
      x:
        event.clientX -
        containerRect.left +
        transcriptContainerRef.current.scrollLeft,
      y:
        event.clientY -
        containerRect.top +
        transcriptContainerRef.current.scrollTop +
        14,
    });
  };
  const navigate = useNavigate();
  // const location= useLocation()
  const path = useLocation();
  const refreshPage = () => {
    // navigate(`${data.uuid}/basic`, { replace: false });
  };

  const generateTransciption = (intervalId?: NodeJS.Timeout) => {
    let src;
    if (transcribe?.type === "call_recordings") {
      src = transcribe.recordings_l[0]?.file_path.replace(
        "/opt/vaspian/data/recordings/",
        "",
      );
    } else if (transcribe?.type === "legacy_call_recordings") {
      src = transcribe.recordings_l[0]?.file_path.replace(
        "/vdata/shared/recordings/",
        "",
      );
    }
    const payload = {
      file_path: src,
      call_type: transcribe?.type,
    };

    setTranscriptLoading(true);

    callTranscript(payload).then((result: any) => {
      if (result.success) {
        setTranscript(result.data);
        setDiarisation(TranscriptSegmentation(result.data.transcript));
        setTranscriptLoading(false);
        setProcessCompleted(result?.data?.is_completed);
        // ✅ Stop polling
        if (intervalId) clearInterval(intervalId);
      } else {
        setTranscript("");
        setProcessCompleted(false);
        // setTranscriptLoading(false);

        // 🔁 If it's a manual trigger and polling isn't active, start it
        if (!intervalId) {
          handleRegenerate();
        }
      }
    });
  };

  const handleRegenerate = () => {
    if (regenLoading) return;

    setRegenLoading(true);
    let src;
    if (transcribe?.type === "call_recordings") {
      src = transcribe.recordings_l[0]?.file_path.replace(
        "/opt/vaspian/data/recordings/",
        "",
      );
    } else if (transcribe?.type === "legacy_call_recordings") {
      src = transcribe.recordings_l[0]?.file_path.replace(
        "/vdata/shared/recordings/",
        "",
      );
    }
    regenerateTranscript({
      file_path: src,
      direction: transcribe?.direction,
      call_type: transcribe?.type,
    }).then((result) => {
      setRegenLoading(false);

      // if (!result.success) {
      //   Notification(
      //     "Failed",
      //     result?.message?.charAt(0).toUpperCase() + result?.message?.slice(1),
      //     "danger"
      //   );
      // } else {
      //Start polling every 6 seconds
      const intervalId = setInterval(() => {
        generateTransciption(intervalId);
      }, 6000);
      // }
    });
  };

  useEffect(() => {
    setInitialLoading(true);
    generateTransciption();
    fetchAudio();
  }, []);

  const [isSummaryExpanded, setIsSummaryExpanded] = useState(false);
  const [isSummaryOverflowing, setIsSummaryOverflowing] = useState(false);
  const summaryRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (summaryRef.current) {
      setIsSummaryOverflowing(
        summaryRef.current.scrollHeight > summaryRef.current.clientHeight,
      );
    }
  }, [transcript?.summary, transcriptLoading]);

  return (
    <div
      //     className={`transition-all duration-500 ${
      //       transcriptLoading
      //         ? "w-[calc(100vw_-_16.5rem)]"
      //         : ` w-[calc(100vw_-_8.5rem)]
      // min-w-[calc(100vw_-_8.5rem)] max-w-[calc(100vw_-_8.5rem)]`
      //     }  `}
      className={`transition-[width] duration-500 ${
        isLoading
          ? "w-[calc(100vw_-_8.5rem)] max-h-[85vh] overflow-y-auto"
          : "w-[calc(100vw_-_8.5rem)] max-h-[85vh] overflow-y-auto"
      }`}
    >
      {
        <div className="">
          <div className="bg-[#FEF4E9] rounded-[5px] p-6">
            <div className="w-full mb-6">
              {!transcriptLoading && transcript?.summary?.length === 0 ? (
                <div className="mb-2 mr-2 inline-block bg-[#00000012] capitalize px-2 py-1 rounded-lg">
                  No summary available
                </div>
              ) : (
                <>
                  <div className="text-xl font-thik mb-2 ">Summary</div>
                  <div
                    ref={summaryRef}
                    className={`relative overflow-hidden transition-all duration-500 ease-in-out ${
                      isSummaryExpanded
                        ? "max-h-[full] opacity-100 translate-y-0"
                        : "max-h-[100px] opacity-90 -translate-y-1 overflow-hidden"
                    }`}
                  >
                    {transcriptLoading && !processCompleted ? (
                      <div className="h-[100px] flex justify-center items-center">
                        <Lottiefy
                          loop={true}
                          json={loaderLottie}
                          height={50}
                          width={50}
                        />
                      </div>
                    ) : transcript?.summary ? (
                      transcript?.summary.replace(/\*/g, "").replace(/#/g, "")
                    ) : (
                      ""
                    )}
                  </div>
                  {isSummaryOverflowing && !transcriptLoading && (
                    <button
                      onClick={() => setIsSummaryExpanded(!isSummaryExpanded)}
                      className="text-[blue] text-sm mt-1 hover:underline focus:outline-none font-medium"
                    >
                      {isSummaryExpanded ? "Read Less" : "Read More"}
                    </button>
                  )}
                </>
              )}
            </div>
            <div className="w-full">
              {Array.isArray(transcript?.keywords) &&
              transcript?.keywords.length === 0 ? (
                <div className="mb-2 mr-2 inline-block bg-[#00000012] capitalize px-2 py-1 rounded-lg">
                  No keywords available
                </div>
              ) : (
                <>
                  <div className="text-xl font-thik mb-2 ">Keywords</div>
                  <div className="max-h-[100px] overflow-y-auto">
                    {transcriptLoading && !processCompleted ? (
                      <div className="h-[100px] flex  items-center">
                        <Lottiefy
                          loop={true}
                          json={loaderLottie}
                          height={50}
                          width={50}
                        />
                      </div>
                    ) : (
                      transcript?.keywords?.map((item: any, index: number) => {
                        return (
                          <div
                            className="mb-2 mr-2 inline-block bg-[#00000012] capitalize px-2 py-1 rounded-lg"
                            key={index}
                          >
                            {item}
                          </div>
                        );
                      })
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
          {isLoading ? (
            <div
              className={`border opacity-50 p-8 border-primary rounded-[5px] mt-4 ${fixedHeight}`}
            >
              <Loader />
            </div>
          ) : (
            <div
              className={`border py-2 pb-4 px-2  border-primary rounded-[5px] mt-4 ${fixedHeight}`}
            >
              <div>
                <div ref={waveformRef} className="overflow-hidden"></div>
                <div className="flex items-center justify-center mt-2">
                  <div className="flex items-center">
                    <Tooltip title="Seek Backward">
                      <button
                        onClick={seekBackward}
                        className="ml-4 scale-150  hover:text-primary"
                      >
                        <KeyboardDoubleArrowLeftIcon />
                      </button>
                    </Tooltip>
                    <Tooltip title={isPlaying ? "Pause" : "Play"}>
                      <button
                        className="ml-4 cursor-pointer scale-150 hover:text-primary"
                        onClick={togglePlay}
                      >
                        {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
                      </button>
                    </Tooltip>
                    <Tooltip title="Seek Forward">
                      <button
                        onClick={seekForward}
                        className="ml-4 scale-150  hover:text-primary"
                      >
                        <KeyboardDoubleArrowRightIcon />
                      </button>
                    </Tooltip>
                    <div className="ml-4 ">
                      {formatTime(currentTime)} / {formatTime(duration)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className=" pt-4 flex justify-between items-center">
            <div className="flex">
              <div className="text-xl pr-8">Transcript</div>
              <div
                onClick={() => {
                  handleRegenerate();
                  setTranscriptLoading(true);
                }}
                className={`p-1 px-4 border border-primary rounded-md ${
                  regenLoading ? "cursor-not-allowed" : "cursor-pointer"
                } hover:bg-primary-alpha-20 `}
              >
                <div className="flex">
                  <div className="pr-2 p-1">
                    {regenLoading ? (
                      <div className="-m-1">
                        <Loader size="sm" />
                      </div>
                    ) : (
                      <RegenerateIcon />
                    )}
                  </div>
                  Regenerate
                </div>
              </div>
            </div>
            <div className="flex items-center">
              <div className="relative">
                <input
                  type="text"
                  autoFocus
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  className="mr-6 w-[400px] border border-gray rounded-[5px] px-2 pr-[140px] py-1"
                  placeholder="Search"
                />
                <div className="absolute right-8 top-1 cursor-pointer">
                  {searchText === "" ? (
                    <SearchIcon
                      onClick={() => {
                        setSearchText("");
                      }}
                    />
                  ) : (
                    <div className="absolute flex right-0 top-0 text-[#1256FE] cursor-pointer ">
                      {!searchResults ? (
                        <div className="w-[100px] text-right text-[red] mr-2">
                          No results
                        </div>
                      ) : (
                        <div className="flex items-center">
                          <div className="w-[60px] text-right mr-2">
                            {currentIndex + 1} of{" "}
                            {highlightsRef?.current?.length
                              ? highlightsRef.current.length
                              : 0}
                          </div>
                          <button onClick={handlePrev}>
                            <UpArrow />
                          </button>
                          <button onClick={handleNext}>
                            <DownArrow />
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="flex gap-x-4">
                <div
                  className={`text-[#1256FE] ${
                    transcriptLoading ? "cursor-not-allowed" : "cursor-pointer"
                  } flex items-center`}
                  onClick={() => {
                    if (!transcriptLoading) downloadTranscript();
                  }}
                >
                  <CustomTooltip
                    title={`${
                      transcriptLoading ? "" : "Download Transcript as .txt"
                    }`}
                  >
                    <TextFileIcon
                      fill={`${transcriptLoading ? "#d3d3d3" : "#4d73d2ff"}`}
                    />
                  </CustomTooltip>
                </div>
                <div
                  className={`text-[#1256FE] ${
                    isLoading ? "cursor-not-allowed" : "cursor-pointer"
                  } flex items-center`}
                  onClick={() => {
                    if (!isLoading) downloadAudio();
                  }}
                >
                  <CustomTooltip
                    title={`${isLoading ? "" : "Download Audio as .mp3"}`}
                  >
                    <AudioFileIcon
                      fill={`${isLoading ? "#d3d3d3" : "#4d73d2ff"}`}
                    />
                  </CustomTooltip>
                  {/* <div className="ml-2">mp3</div> */}
                </div>
              </div>
            </div>
          </div>
          <div
            ref={transcriptContainerRef}
            onMouseDown={handleMouseDown}
            className="border selection relative border-[#fed8af] rounded-[5px] p-4 mt-4 h-[calc(100vh-600px)] overflow-y-auto"
          >
            {transcriptLoading ? (
              // <Backdrop className="!z-[99999999999]" open={transcriptLoading}>
              <div className="h-[calc(100vh-640px)] flex justify-center items-center">
                <Lottiefy
                  loop={true}
                  json={loaderLottie}
                  height={70}
                  width={70}
                />
              </div>
            ) : diarisation.length === 0 ? (
              <div className="pt-16 text-center text-[#999]">
                No transcript available
              </div>
            ) : (
              diarisation.map((item: any, index: number) => {
                return (
                  <div
                    className="text-[16px] p-[4px]"
                    key={index}
                    ref={(el) => (transcriptRefs.current[index] = el)} // Assign ref to each transcript
                  >
                    <div
                      onClick={() => playFromTime(item.start_time / 1000)}
                      className={`${
                        currentTime * 1000 > item.start_time &&
                        currentTime * 1000 < item.end_time
                          ? "text-primary"
                          : ""
                      }  text-[#000C39]`}
                    >
                      {item.speaker
                        ? `${item.speaker} (${formatTime(
                            item.start_time / 1000,
                          )})`
                        : ""}{" "}
                    </div>
                    <div
                      onMouseUp={(event) => handleMouseUp(item)}
                      // onClick={() => playFromTime(item.start_time / 1000)}
                      className={`border w-[calc(100%-100px)]  text-[gray] italic border-none cursor-pointer hover:border-[#fed8af] ${
                        currentTime * 1000 > item.start_time &&
                        currentTime * 1000 < item.end_time
                          ? "text-primary"
                          : ""
                      }`}
                    >
                      "
                      {item.textParts.map((part: any, pIndex: number) => {
                        return (
                          <div
                            // onClick={(e) => playFromTime(part.start_time / 1000)}
                            key={index + "_" + pIndex}
                            className={`inline-block  ${
                              currentTime * 1000 > part.start_time &&
                              currentTime * 1000 < part.end_time
                                ? "bg-[#f7efe6] text-[#a37503]"
                                : ""
                            }`}
                          >
                            <div
                              className="inline-block"
                              dangerouslySetInnerHTML={{
                                __html: highlightText(part.chunk),
                              }}
                            ></div>
                            <>&nbsp;</>
                          </div>
                        );
                      })}
                      "
                    </div>
                  </div>
                );
              })
            )}
            {selectedText && (
              <div
                ref={menuRef}
                className="absolute bg-[white] w-[160px] shadow-md border border-[#d9d9d9] p-1 rounded-md"
                style={{
                  top: `${menuPosition.top}px`,
                  left: `${menuPosition.left}px`,
                }}
              >
                <div
                  className="flex gap-1 p-1 py-2 hover:bg-primary-alpha-20 hover:text-white cursor-pointer"
                  onClick={(e) => playFromTime(playItem?.start_time / 1000)}
                >
                  <div className="p-1">
                    <PlayButton />
                  </div>
                  Play
                </div>
                <div
                  className="flex gap-1 p-1 py-2 hover:bg-primary-alpha-20 hover:text-white cursor-pointer"
                  onClick={() => setTrainingModal(true)}
                >
                  <div className="px-1">
                    <CircleTick />
                  </div>
                  Correct me
                </div>
              </div>
            )}
          </div>
        </div>
        // )
      }
      {trainingModal && (
        <Modal title={"Train Your Model"} closeEvent={onCloseModal}>
          <FadeIn>
            <TrainYourModel
              item={playItem}
              audioBlob={audioBlob}
              selectedText={selectedText}
              onCloseModal={onCloseModal}
            />
          </FadeIn>
        </Modal>
      )}
    </div>
  );
};

export default TranscribeModalCopy;
